import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import ResourcePageComponent from '../../components/Resources/Resource/ResourcePages/ResourcePageComponent';
import { apiRequest } from '../../components/util/requests/requests';
import { Resource } from './index';

export interface ResourcePageProps {
    resource: Resource;
    resources: Array<Resource>;
}

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
    let resource = await apiRequest(
        `/resources?filters[seoUrl][$eq]=${params.resourcePage}&populate=*`
    );

    const resources = await apiRequest('/resources?populate[0]=mainImage');

    return {
        props: {
            resource: resource.data[0] ?? {},
            resources: resources.data ?? [],
        },
    };
};

const ResourcePage = ({ resource, resources }: ResourcePageProps) => {
    const router = useRouter();
    const { resourcePage } = router.query;

    if (router.isFallback) {
        return (
            <Layout defaultMetaTitle={'Noria.no - Fetching resources page..'}>
                <div>Fetching resources page..</div>
            </Layout>
        );
    }

    if (resource && resources && resourcePage) {
        return (
            <Layout seoMetadata={resource.seo} defaultMetaTitle={`Noria.no - ${resource.ingress}`}>
                <ResourcePageComponent resource={resource} resources={resources} />
            </Layout>
        );
    } else {
        return (
            <Layout defaultMetaTitle={'Noria.no - No work resources found.'}>
                <p>No work resources found.</p>
            </Layout>
        );
    }
};

export default ResourcePage;
